import RequestSummarySectionModelBase from '../_generated/modelBases/request-summary-section-model-base';

export default class RequestSummarySectionModel extends RequestSummarySectionModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
